<template>
  <div class="cover">
    <span style="font-size: 16px">跳转链接中...</span>
  </div>
</template>

<script>
export default {
  mounted() {
    let path = this.$route.query.path;


    this.$bsUtils.nativeApi.jumpPage(
      'wdmp://mp.wanda.cn/launchbrowser?url=' + encodeURIComponent(path)
    );

    console.log(encodeURIComponent(path));
  },
};
</script>

<style lang="less" scoped>
.cover {
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
}

.guide {
  text-align: right;
  img {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
}

.line {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}
</style>